import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalService } from '../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-billprepaid',
  templateUrl: './billprepaid.component.html',
  styleUrls: ['./billprepaid.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class BillprepaidComponent implements OnInit {
  public tabActive = 'Pagos y Facturas';
  public selectBan;
  public banlist;
  public currentList;
  public postpago;
  public prepago;
  public type;
  public telefoniaFijo;
  public totalAccountList;
  public subscribers = [];
  public subscriber;
  public accounInfo;
  public token: string;
  public balanceP;
  public endDate;
  public rateplaninfo;
  public totalplaninfo;
  public descrplaninfo:string='';
  public planType:string='';
  public planFeatures:string[];
  public planDesc: any;
  public lastrecharge;
  public rechargedate;
  public ewalletbalance;
  public lastPrepaidReplenishment;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, private router: Router, public global: GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Resumen de Cuenta");
    this.AngularFireAnalytics.logEvent("Resumen de Cuenta-Screenview");
  }

  ngOnInit() {
    this.global.validateSession();
    if (this.global.sessionReview() == true) {
      this.token = sessionStorage.getItem("token");
      this.subscriber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField;
      this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      //this.subscribers[1]=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0]; cable para pruebas con mas data de suscriptores
      this.findData(0);
    }
  }
  goTransacciones(){
    this.router.navigate(['Transacciones']);
  }
  findData(i) {
    this. balanceP = this.subscribers[i].prepaidBalanceField;
    this.endDate = this.subscribers[i].planInfoField.endDateField;
    this.totalplaninfo = this.subscribers[i].planInfoField.totalRateField;
    this.rateplaninfo = this.subscribers[i].planInfoField.socRateField;
    this.descrplaninfo = this.subscribers[i].planInfoField.sOCDescriptionField;
    this.ewalletbalance = this.subscribers[i].eWalletBalanceField;
    this.planDesc = this.subscribers[i].planInfoField.sOCDescriptionInfoField;
    if(this.descrplaninfo.length>0){
      let aux=this.descrplaninfo;
      let auxFeatures=this.descrplaninfo.substring(aux.indexOf(":")+2,aux.length);
      auxFeatures=auxFeatures.replace("&","/");
      this.planType=this.descrplaninfo.substring(0,aux.indexOf(":"));
      this.planType=this.planType.trim();
      this.planFeatures=auxFeatures.split(" ");
    }
    if (this.subscribers[i].planInfoField.lastrecharge != undefined) {
      this.lastrecharge = this.subscribers[i].planInfoField.lastrecharge;
    }
    else {
      this.lastrecharge = 0;
    }
    if (this.subscribers[i].planInfoField.rechargedate != undefined) {
      this.rechargedate = new Date(this.subscribers[i].planInfoField.rechargedate);
    }
    else if (this.subscribers[i].lastPrepaidReplenishmentDateField != undefined) {
      this.rechargedate = new Date(this.subscribers[i].lastPrepaidReplenishmentDateField);
    }
    if (this.subscribers[i].lastPrepaidReplenishmentField != undefined) {
      this.lastPrepaidReplenishment = this.subscribers[i].lastPrepaidReplenishmentField;
    }
    // if (this.subscribers[i].planInfoField.ewalletbalance != undefined) {
    // }
    else if (this.subscribers[i].eWalletBalanceField != undefined) {
      this.ewalletbalance = parseFloat(this.subscribers[i].eWalletBalanceField);
    }
    else {
      this.ewalletbalance = 0;
    }

    this.accounInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
    if (this.global.sessionReview() == true) {
      this.banlist = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
    }
  }
  refreshDataTo(event: Event) {
    this.findData(parseInt(event.target["selectedIndex"]));
    //let ban = this.currentList[index].account;
    //sessionStorage.setItem("selectBan", btoa(ban));
    //this.initializeData();
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  goToRecharge() {
    this.router.navigate(['recharge']);
  }
  dataLoading(sw) {
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.accounInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
  }
  goTransaction() {
    this.router.navigate(['transactions']);
  }
  printBill(print1, pintableDiv) {
    var printContents1 = document.getElementById(print1).innerHTML;
    var printContents = document.getElementById(pintableDiv).innerHTML;
    var mywindow = window.open('', 'new div', 'height=400,width=600');
    mywindow.document.write('<html><head><title></title>');
    mywindow.document.write(`
      <style>
      body{
        font-family: 'AMX-Regular', BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        font-weight: 400;
        line-height: 1.5;
        padding: 0px 20px 20px 20px;
      }
      .permit,.optchoice,.boxtbl,.log-gbg,.logside,.autorow,.autocont,.htopbar,.allcont,.footcont,.basicrow{
        width: 100%;
        height: auto;
        float: left;
      }
      .mbott{
        margin-bottom: 30px;
      }
      .m-top{
        margin-top: 20px;
      }
      .allpads{
        padding: 20px;
      }
      .basicrow.bordsdef{
        border: 1px solid #cccccc;
      }
      .text-justify{
        text-align: justify;
      }
      .clBox{
        display: block;
      }
      .m-top-u-i{
        margin-top: 6px;
      }
      .balancesptr-i, .balancesptr-ii, .balancesptr-iii, .balancesptr-iv{
        width: 33.33% !important;
        height: auto;
        min-height: 64px;
        float: left;
        padding-right: 2%;
        border-right: 1px solid #ccc;
        margin-bottom: 23px;
      }
      .text-center{
        text-align: center;
      }
      .roboto-b{
        font-family: 'Roboto', sans-serif;
        font-weight: 700;
      }
      .f-red{
        color: #ef3829;
      }
      .f-lsemi{
        font-size: 30px;
        line-height: 35px;
      }
      .text-right{
        text-align: right;
      }
      .mbott{
        margin-bottom: 30px;
      }
      .logline{
        width: 70px;
        height: 1px;
        background-color: #cccccc;
        display: block;
        margin: 0 auto;
      }
      .logline.full{
        width: 100%;
        float: left;
      }
      .spacing-line{
        margin-bottom: 15px;
      }
      .pull-left{
        float: left!important;
      }
      .f-big{
        font-size: 24px;
      }
      .espacing{
        margin-top: 15px;
      }
      .box-general{
        width: 100%;
        padding-top: 20px;
      }
      .box-general2{
        width: 100%;
        padding-top: 10px;
      }
      .bg-item1{
        width: 66%;
        float: left;
        padding-top: 20px;
      }
      .bg-item11{
        width: 100%;
        float: left;
        padding-top: 20px;
      }
      .bg-item2{
        width: 34%;
        float: right;
        padding-top: 20px;
      }
      .btnr{
        display: none;
      }
      .title-descr{
        width: 33%;
        float: left;
        font-weight: 500;
      }
      .descr-plan{
        text-align: justify;
        padding-top: 10px;
        width: 66%;
        float: left;
      }
      .total-title{
        text-align: justify;
        padding-top: 10px;
        font-size: 24px;
        font-weight: 500;
        width: 66%;
      }
      .chart-elem{
        margin:20px;
        border:1px solid;
        border-radius: 5px;
        height: 200px;
        cursor: pointer;
      }
      .alt-elem{
        padding-top: 32px;
      }
      .title-descr2{
        width: 34%;
        float: right;
        font-weight: 500;
        text-align: right;
        margin-top: 0;
      }
      .box-selector{
        margin-top: 0px;
      }
      .vis{
        display: block;
      }
      .spacing-links2{
        padding-top: 20px;
        text-align: right;
        width: 34%;
        float: right;
      }
      .box-general-mov{
        display: none;
      }
      .bg-item1.exten{
        width: 100%;
      }
      .text-sep{
        padding-top: 10px;
        text-align: right;
      }
      .text-sep1{
        text-align: left;
      }
      .text-sep11{
        text-align: left;
        width: 33%;
      }
      .clBox{
        height: 50px;
        width: 100%;
        background-color: #ef3829;
        -webkit-print-color-adjust: exact;
        text-align:center;
      }
      .cLogo{
        width: 123px;
        height: 35px;
        vertical-align: middle;
      }
      </style>
      `);
    mywindow.document.write('</head><body>');
    mywindow.document.write(printContents1);
    mywindow.document.write(printContents);
    mywindow.document.write('</body></html>');
    mywindow.document.close();
    //mywindow.focus();
    setTimeout(function () { mywindow.print(); }, 1000);
    return true;
  }
  goAtenttionCenter() {
    let link = "https://www.claropr.com/personas/soporte/atencion-cliente/";
    window.open(link, "_blank");
  }
}
